const zIndex = 9999
const dropdownHeight = 35
const bufferSize = 25
const dropdownPlacementTopValue = dropdownHeight + bufferSize

export { zIndex, dropdownPlacementTopValue }
